// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

// I136: the product-variant hook and helpers live apart from the provider component.
// A module that exports both a component and non-components defeats React Fast Refresh
// — editing it reloads the page instead of preserving state — which is what
// react-refresh/only-export-components warns about.

import { createContext, useContext } from 'react';

export type ProductVariant = 'v1' | 'v2';

export function resolveVariant(): ProductVariant {
  const raw = (import.meta.env.VITE_PRODUCT_VARIANT ?? '').toLowerCase().trim();
  return raw === 'v2' ? 'v2' : 'v1';
}

export const VariantContext = createContext<ProductVariant>(resolveVariant());

export function useProductVariant(): ProductVariant {
  return useContext(VariantContext);
}

export function isV2(v: ProductVariant): boolean {
  return v === 'v2';
}
